import { useEffect, useMemo, useState } from 'react';

import { getImageRatio, measureElement } from 'containers/world/utils';

import { GetChart } from 'components/Dashboard/GetChart';
import { NOCChart } from 'components/Dashboard/NOCChart';
import { IconLoading } from 'containers/hotspots/icons/iconLoading';
import adminApi from 'services/adminApi';
import './popup.infoBox.scss';

function PopupInfoBox(props) {
  const [imgRatio, setImgRatio] = useState(1);
  const { title, text, imageUrl, id } = props.media;
  const [popupHeight, setPopupHeight] = useState(0);
  const [flex, setFlex] = useState('center');
  const [dashboardData, setDashboardData] = useState();
  const finalId = text.replace('dashboard:', '');
  const [chartData, setChartData] = useState();

  const isNOC = finalId === 'NOC';

  useEffect(() => {
    const timeout = setTimeout(() => {
      props.setHotspotHovering(true);
    }, 100);
    return () => clearTimeout(timeout);
  }, [props]);

  useEffect(() => {
    if (text.includes('dashboard')) {
      // setDashboardData(props.media.configs);

      if (isNOC) {
        const fetchData = async () => {
          const res = await adminApi({ url: '/dashboard' });
          const result = await res.json();
          setChartData(result.data);
        };
        fetchData();
      } else {
        const fetchData = async () => {
          const response = await adminApi({
            url: `/dashboard/${finalId}`,
          });
          const data = await response.json();
          if (data?.data) {
            setDashboardData(data?.data);
          }
        };
        fetchData();
      }
    }
  }, [finalId, id, isNOC, text]);

  const dashboard = useMemo(() => {
    if (!dashboardData) return [];

    return JSON.parse(dashboardData?.data);
  }, [dashboardData]);

  // const popupContentWpStyle = useMemo(() => {
  //   const condition = imgRatio > 0.75;

  //   if (isMobileOnly) {
  //     return {
  //       width: condition
  //         ? `calc(100% - 20px)`
  //         : `calc(${85 * imgRatio}vh - 40px)`,
  //     };
  //   }

  //   if (isTablet) {
  //     return {
  //       width: condition ? `calc(100vw - 40px)` : `${85 * imgRatio}vh`,
  //     };
  //   }

  //   return {
  //     width: finalId
  //       ? 'undefined'
  //       : condition
  //       ? `${67.5 * imgRatio}vh`
  //       : `${85 * imgRatio}vh`,
  //   };
  // }, [imgRatio, finalId]);

  useEffect(() => {
    getImageRatio(imageUrl)
      .then((result) => {
        setImgRatio(result);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [imageUrl]);

  useEffect(() => {
    if (popupHeight && popupHeight > window.innerHeight) {
      setFlex('flex-start');
    } else setFlex('center');
  }, [popupHeight]);

  const formatDate = (date) => {
    const dateObj = new Date(date);
    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1; // Lưu ý: Tháng bắt đầu từ 0
    const year = dateObj.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  };

  return (
    <div
      className="Popup-content Popup-content-infobox"
      style={{ alignItems: flex }}
    >
      {imgRatio && (
        <div
          className="Popup-content-wp"
          // style={popupContentWpStyle}
          ref={(node) => measureElement(node, 'height', setPopupHeight)}
        >
          {dashboard?.length || chartData?.length ? (
            <div
              className={`infobox-table-wp  ${isNOC ? 'noc-room' : ''} ${
                finalId ? 'popup-dashboard' : ''
              }`}
            >
              {isNOC ? (
                <NOCChart finalId={finalId} chartData={chartData} />
              ) : (
                <GetChart finalId={finalId} dashboard={dashboard} />
              )}
            </div>
          ) : (
            <div
              className={`infobox-img-wp ${
                imgRatio > 0.75 ? 'landscape-maxheight' : 'portrait-maxheight'
              }`}
            >
              {finalId ? <IconLoading /> : <img src={imageUrl} alt={title} />}
            </div>
          )}
          {!isNOC && (
            <div className="infobox-text-wp">
              <div className="infobox-title">
                <h2 style={{ margin: '0' }}>{title}</h2>
                <p style={{ fontSize: '16px', color: 'white', margin: '0' }}>
                  {formatDate(dashboardData?.updatedAt)}
                </p>
              </div>
              <div className="infobox-description"></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default PopupInfoBox;
